export function registerReducer(state = [], action) {
    switch (action.type) {
        case 'STEP_POSITION':
            return {
                ...state,
                position: action.payload,
            };
        case 'REFRESH_REGISTRATION':
            return {};
        case '@@redux-form-license/SET_DATA':
            return {
                ...state,
                license: action.payload,
            };
        case '@@redux-form-identity/SET_DATA':
            return {
                ...state,
                identity: action.payload,
            };
        case '@@redux-form-email/SET_DATA':
            return {
                ...state,
                email: action.payload,
            };
        case '@@redux-form-personalDetails/SET_DATA':
            return {
                ...state,
                personalDetails: action.payload,
            };

        case '@@redux-form-fiscalCode/SET_DATA':
            return {
                ...state,
                fiscalCode: action.payload,
            };
        default:
            return state;
    }
}
